import React from 'react'
import { Typography } from 'antd'
import { useAppSelector } from 'src/app/hooks'
import { selectCurrencyToken } from 'src/features'
import { getFormatedPrice } from 'src/core/helpers'

interface PropsType {
  total: number
  isStrong?: boolean
}

const CustomTotalColumn = (props: PropsType) => {
  const { total, isStrong = false } = props
  const currency_code = useAppSelector(selectCurrencyToken)

  return (
    <div className={'centered-div'}>
      <Typography.Title level={5}>
        {isStrong ? (
          <strong>{getFormatedPrice(total, currency_code)}</strong>
        ) : (
          <>{getFormatedPrice(total, currency_code)}</>
        )}
      </Typography.Title>
    </div>
  )
}

export default CustomTotalColumn
